const CreditCard = ({ ...props }) => {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3 10.5C3 10.225 3.225 10 3.5 10H5.5C5.775 10 6 10.225 6 10.5C6 10.775 5.775 11 5.5 11H3.5C3.225 11 3 10.775 3 10.5ZM7 10.5C7 10.225 7.225 10 7.5 10H11.5C11.775 10 12 10.225 12 10.5C12 10.775 11.775 11 11.5 11H7.5C7.225 11 7 10.775 7 10.5ZM0 2C0 0.895313 0.895313 0 2 0H16C17.1031 0 18 0.895313 18 2V12C18 13.1031 17.1031 14 16 14H2C0.895313 14 0 13.1031 0 12V2ZM1 2V3H17V2C17 1.44781 16.5531 1 16 1H2C1.44781 1 1 1.44781 1 2ZM1 6H17V4H1V6ZM1 7V12C1 12.5531 1.44781 13 2 13H16C16.5531 13 17 12.5531 17 12V7H1Z" fill="#464544"/>
    </svg>
  )
}

export default CreditCard
